import type { PropsWithChildren } from 'react';
import { createContext, useMemo } from 'react';
import { useContextOrThrow } from '@elfsight/lib-utils';
import { useLingui } from '@lingui/react/macro';
import type { DomainTextsContextProps } from '../common';
import { TextsDomains } from '../common';

export type WidgetDomainTexts = {
  payButtonActionText: string;
};

const WidgetDomainTextsContext = createContext<WidgetDomainTexts>({
  payButtonActionText: ''
});

export function WidgetDomainTextsProvider({
  domain = 'default',
  children
}: PropsWithChildren<DomainTextsContextProps>) {
  const { t } = useLingui();

  const texts = useMemo(
    () =>
      ({
        [TextsDomains.Default]: {
          payButtonActionText: t`Pay & Proceed`
        },
        [TextsDomains.AppointmentBooking]: {
          payButtonActionText: t`Pay & Confirm Booking`
        }
      })[domain],
    [t, domain]
  );

  return (
    <WidgetDomainTextsContext.Provider value={texts}>
      {children}
    </WidgetDomainTextsContext.Provider>
  );
}

export function useWidgetDomainTexts(): WidgetDomainTexts {
  return useContextOrThrow(WidgetDomainTextsContext, 'WidgetDomainTexts');
}
